// These are types that can be declared to help enforce API <-> Client contracts, and
//  help with the debugging and ongoing maintenance of those calls.

export const DEFAULT_COLLECTION = 'Default';

export const COMPRESSED_FILE_SUFFIX = '.gz';

// Useful for turning paragraph breaks into sentence breaks or just adding more breaks
// The end result is text without extra viewable/parsable punctuation
export const FORCED_SENTENCE_TERMINATOR = '\x1f';
export const FORCED_TERMINATOR_REPLACEMENT = ' ';

// Track existing versions of table spec storage
// If we have tables in production and need to update the spec, this
//  will help us know which versions are outstanding and need to be handled.
export enum TABLE_PARSE_VERSION {
    v6 = 'v6',   // Article with title text only in table data
    v6b = 'v6b', // Pay attention to empty paragraphs. (writing out article sentence)
    v6c = 'v6c', // Handle malformed(sparse) tables where column counts differ between rows
    v6d = 'v6d', // Table pseudo paragraph support and alternate title derivation (previous paragraph & single cell table rows)
    v6e = 'v6e', // Ignore unneeded colspans instead of duplicating
}

export const ALL_SELECTIONS = '_all';

// General Create/Update Contracts
// Return type for communicating success in creating new data
export interface ICreate {
    newRowId: number;
}

// Return type for communicating success in updating data
export interface IUpdate {
    rowsUpdated: number;
}

export const NOVELTY_REPORT_DELIMITER = '|';

export type GenericMap = { [ key: string ]: string };

// Structure mounted endpoint details to help track format
// In shared because both server and front end code
export interface IApiHostInfo {
    name: string; // API
    // path should probably be renamed to something like str, but we need a way to refresh
    //  existing local storage if it is renamed
    path: string; // usually /api or http://127.0.0.1:3000
}

// Communication with OpenAI
export interface IChatResponse {
    model: string;
    error?: { code: string, message: string };
    choices: { index: number, message: { content: string, role: string }, finish_reason: string }[],
    created: number;
    id: string;
    object: string;
    usage: { prompt_tokens: number, completion_tokens: number, total_tokens: number }
}

// This is a gzip stream compatible writer + generic handler required methods
export interface IResponseWithStreamingHandlers {
    json?: (GenericMap) => void;
    send?: (GenericMap) => void;
    setHeader: (key: string, value: string) => void;
}
